import { Select, MenuItem} from '@mui/material';



export const KeyPicker = ({keys, setKey, selected_key, human_readable}) => {

    const makeMenuItems = (avkeys) => {
        return avkeys.map(
            (avkey) => <MenuItem key={avkey} value={avkey}> {human_readable[avkey]} </MenuItem> 
        ) 

    }

    const handleChange = (event) => {
        setKey(event.target.value)

    }

    return (
      <Select
        size="small"
        label="plot"
        value={selected_key}
        onChange = {handleChange}
        sx={{ fontSize: 12 }}
      >
        {makeMenuItems(keys)}
    </Select>
    
   


    );
  }

